module.exports = __webpack_public_path__ + "img/empty-folder.ad86098c.png";